import { OnInit } from '@angular/core';
import { resolveThemeCssClass } from '../lib/helper/panel-settings';
import { NewsOverviewService } from './service/news-overview.service';
var NewsPanelComponent = /** @class */ (function () {
    function NewsPanelComponent(newsService) {
        this.newsService = newsService;
    }
    Object.defineProperty(NewsPanelComponent.prototype, "hostClasses", {
        get: function () { return resolveThemeCssClass(this.data.panelSettings); },
        enumerable: true,
        configurable: true
    });
    NewsPanelComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.newsList = this.getNews();
        this.newsList.subscribe(function (response) {
            _this.newsArray = response.items;
        });
    };
    NewsPanelComponent.prototype.getNews = function () {
        var DEFAULT_NEWS_COUNT = 3;
        var newsCount = this.data.previewsCount ? this.data.previewsCount.value : DEFAULT_NEWS_COUNT;
        var initialSettings = {
            year: null,
            index: 0,
            step: newsCount
        };
        return this.newsService.getNews(initialSettings);
    };
    return NewsPanelComponent;
}());
export { NewsPanelComponent };
